import state from './settings.state'
import mutations from './settings.mutations'
import actions from './settings.actions'
import getters from './settings.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
